// extracted by mini-css-extract-plugin
export default {"hideTooltip":"_9-z","fadeIn":"a--z","delay":"b--z","recommendedSizeTooltip":"c--z"};